import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'

import { resolveDisputeReject } from '../../core/api'
import { buildDisputeErrorText, disputeErrorFromException } from '../../core/errors'
import { DisputeRecord, DisputeReasonLookupItem } from '../../core/response.types'
import { DisputeResolveSummary, reasonChange } from '../DisputeResolveSummary/DisputeResolveSummary'

interface Props {
  show: boolean
  dispute: DisputeRecord | null
  reasons: DisputeReasonLookupItem[]
  onClose: () => void
  onResolved: () => void
}

const FALLBACK_ERROR = 'Не удалось отказать по диспуту'

export const ResolveRejectModal: React.FC<Props> = ({ show, dispute, reasons, onClose, onResolved }) => {
  const [reasonId, setReasonId] = useState<number>(0)
  const [submitting, setSubmitting] = useState(false)
  const [generalError, setGeneralError] = useState<string | null>(null)

  useEffect(() => {
    if (show && dispute) {
      setReasonId(dispute.reason.id)
      setGeneralError(null)
    }
  }, [show, dispute])

  if (!dispute) return null

  const submit = async () => {
    setSubmitting(true)
    setGeneralError(null)
    try {
      const r = await resolveDisputeReject(dispute.id, reasonChange(dispute, reasonId))
      if (!r.data.success) {
        setGeneralError(buildDisputeErrorText(r.data, FALLBACK_ERROR))
        return
      }
      onResolved()
      onClose()
    } catch (e: unknown) {
      setGeneralError(disputeErrorFromException(e, FALLBACK_ERROR))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal show={show} onHide={submitting ? () => undefined : onClose} centered>
      <Modal.Header closeButton={!submitting}>
        <Modal.Title>Отказать по диспуту?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DisputeResolveSummary
          dispute={dispute}
          reasons={reasons}
          reasonId={reasonId}
          onReasonChange={setReasonId}
          disabled={submitting}
        />
        <div className='alert alert-warning mb-0'>
          Тикет перейдёт в EXPIRED, чеки будут отклонены. Если оплата подтвердится позже, тикет
          автоматически зачислен <b>не будет</b>.
        </div>
        {generalError && <div className='alert alert-danger mt-4 mb-0'>{generalError}</div>}
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-light' onClick={onClose} disabled={submitting}>
          Отмена
        </button>
        <button type='button' className='btn btn-danger' onClick={submit} disabled={submitting}>
          {submitting ? 'Отказываем…' : 'Отказать'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ResolveRejectModal
